/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

const StyledFieldset = styled.fieldset`
  margin: 0 0 ${theme.spacing.spacing04} 0;
`;

type Props = React.ComponentProps<typeof StyledFieldset>;

export function Fieldset(props: Props) {
  return <StyledFieldset {...props}>{props.children}</StyledFieldset>;
}
